/* eslint-disable max-len */
const faq = `

<div class="accordion-wrapper">

<div class="left">

<div class="accordion">
<input type="checkbox" id="chck2">
<label class="accordion-label" for="chck2">Pendaftaran data pribadi</label>
<div class="accordion-content">
<p>
Anda akan diminta memasukkan data diri seperti KTP, rekening bank, dan NPWP. Pastikan bahwa data yang ingin didaftarkan tidak pernah terdaftar pada akun Easycash sebelumnya.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck3">
<label class="accordion-label" for="chck3">Nominal pendanaan di Easycash</label>
<div class="accordion-content">
<p>
Nominal minimal pendanaan di Easycash adalah Rp1.000.000 dan maksimum pendanaan mulai dari 30 juta rupiah untuk produk eksklusif pengguna baru (periode 30 atau 60 hari) dan 10 miliar rupiah untuk produk pendanaan dengan periode 30 – 360 hari.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck4">
<label class="accordion-label" for="chck4">Suku bunga pendanaan di Easycash</label>
<div class="accordion-content">
<p>
Suku bunga pendanaan menyesuaikan produk pendanaan yang dipilih dan detailnya dapat dicek langsung pada aplikasi. Suku bunga pendanaan bervariasi dan dapat berubah sewaktu-waktu.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck5">
<label class="accordion-label" for="chck5">Bukti potong pajak</label>
<div class="accordion-content">
<p>
Bukti pemotongan pajak atas seluruh transaksi pembayaran bunga pendanaan yang diterima akan dibuat dalam 1 masa pajak yang akan diberikan 1 bulan setelah periode pendanaan berakhir.
<br>
Anda dapat mengajukan permintaan bukti pemotongan pajak dengan mengirimkan email ke : <a href="mailto: cs.lender@easycash.id ">cs.lender@easycash.id </a> dan berikan subject "Permintaan Bukti Potong Pajak" berserta lampiran berikut ini:
<ol>
<li>Nomor handphone yang terdaftar</li>
<li>Email aktif yang digunakan</li>
<li>Apakah menggunakan NPWP gabungan : Ya/Tidak</li>
</ol>
Setelah itu tunggu balasan dari tim email kami.
</p>
<p></p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck6">
<label class="accordion-label" for="chck6">Perhitungan pajak</label>
<div class="accordion-content">
<p>
Berdasarkan peraturan perundang-undangan yang berlaku, platform akan melakukan pemotongan pajak untuk setiap pendanaan Anda di Easycash yang jatuh tempo setelah 1 Mei 2022.
<br>
Tarif pemotongan pajak adalah 15% untuk pengguna yang telah melengkapi data NPWP dan 30% untuk pengguna yang belum melengkapi atau salah melengkapi data NPWP.
</p>
</div>
</div>

</div>

<div class="right">

<div class="accordion">
<input type="checkbox" id="chck7">
<label class="accordion-label" for="chck7">Tanda tangan Privy ID atau tanda tangan digital</label>
<div class="accordion-content">
<p>
Setelah proses top up dana dilakukan, Anda harus melakukan TTD digital sebelum melanjutkan proses pendanaan. Pada saat Anda melakukan tanda tangan Privy ID, pastikan alamat email dan username Privy ID sudah sesuai.
</p>

</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck8">
<label class="accordion-label" for="chck8">Pencairan dana</label>
<div class="accordion-content">
<p>
Ketika pendanaan Anda telah berakhir, nantinya dana yang sudah disalurkan beserta bunga pendanaan akan masuk ke dalam saldo balance akun. Proses penarikan dana dapat dilakukan secara manual dengan waktu H+3 (tiga) hari kerja, tidak termasuk tanggal merah atau hari libur. Anda dapat melakukan penarikan dana dengan catatan berikut:
<ol>
<li>Limit pencairan : 1 miliar rupiah/hari</li>
</ol>

<p>Jika ingin melakukan pencairan 1 miliar rupiah, silakan melakukan pencairan 200 juta rupiah sebanyak 5 kali dalam 1 hari. Jumlah pencairan tersebut tergantung limit bank yang Anda gunakan. Jika Anda menggunakan bank selain BCA, kami sarankan untuk melakukan pencairan tidak lebih dari 100 juta rupiah agar terhindar dari kegagalan penarikan.</p>
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck9">
<label class="accordion-label" for="chck9">Apakah aman menjadi Pemberi Dana di Easycash?</label>
<div class="accordion-content">
<p>
Tentu aman. Sebagai platform yang telah terdaftar dan diawasi oleh OJK, Easycash melakukan proses analisis terhadap calon Penerima Dana dengan sistem kredit self-evolving machine learning yang diperkuat lebih dari 6.000 fitur dan 10 jenis analisis skenario yang dapat merefleksikan keseluruhan kondisi kredit dari Penerima Dana. Easycash menyediakan informasi yang transparan yang dapat diakses melalui fitur yang tersedia di aplikasi.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck10">
<label class="accordion-label" for="chck10">Asuransi</label>
<div class="accordion-content">
<p>
Saat ini pendanaan Anda sudah dilindungi dengan asuransi Intra Asia dan Reliance.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck11">
<label class="accordion-label" for="chck11">Top up dana</label>
<div class="accordion-content">
<p>
Top up dana dapat dilakukan melalui Virtual Account Bank BCA. Jika Anda ingin melakukan top up melalui bank lain, Anda tetap harus menggunakan Virtual Account BCA dengan estimasi waktu dana masuk 1X24 jam.
</p>
</div>
</div>

</div>

</div>


`;

export default faq;
